"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualScroll = void 0;
const react_1 = __importDefault(require("react"));
const react_virtuoso_1 = require("react-virtuoso");
//Use to display placeholders if the user scrolls fast through the list.
const VELOCITY_ENTER = 500;
const VELOCITY_EXIT = 10;
// Set the increaseViewportBy property to artificially increase the viewport size,
// causing items to be rendered outside the viewport.
// The property causes the component to render more items than the necessary,
// but can help with slow loading content and do some caching for a better UX experience.
const INCREASE_VIEWPORT_BY_PIXELS = 250;
function VirtualScroll({ virtuoso, maxViewHeight, heightFromTop = 0, data, itemContent }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_virtuoso_1.Virtuoso, { ref: virtuoso, style: {
                height: `calc(${maxViewHeight}vh - ${heightFromTop}px)`,
                width: '100%'
            }, 
            //The total amount of items to be rendered.
            totalCount: data === null || data === void 0 ? void 0 : data.length, 
            //The data items to be rendered. If data is set, the total count will be inferred from the length of the array.
            data: data, 
            //Advanced customization of the elements rendered by the list.
            components: {
                ScrollSeekPlaceholder: () => (react_1.default.createElement("div", { style: {
                        height: `40px`,
                        padding: '8px',
                        overflow: 'hidden'
                    } },
                    react_1.default.createElement("div", { style: {
                            background: '#DCDCDC',
                            height: `12px`
                        } })))
            }, 
            //Artificially increase the viewport size
            increaseViewportBy: INCREASE_VIEWPORT_BY_PIXELS, scrollSeekConfiguration: {
                //Callback to determine if the list should enter "scroll seek" mode.
                enter: velocity => Math.abs(velocity) > VELOCITY_ENTER,
                //Callback to determine if the list should enter "scroll seek" mode.
                exit: velocity => {
                    return Math.abs(velocity) < VELOCITY_EXIT;
                }
            }, 
            //Set the callback to specify the contents of the item.
            itemContent: itemContent })));
}
exports.VirtualScroll = VirtualScroll;
//# sourceMappingURL=virtual-scroll.js.map